import React from 'react'

import { HeadingExtraLarge, HeadingExtraSmall } from '../Heading'
import { ContentLarge } from '../Content'
import {
  HeroContentWrapper,
  HeroArtwork,
  DealButton,
  customHeadingExtraLarge,
  customHeadingExtraSmall,
  customContentLarge,
  MobileHeroImage,
} from './style'
import MobileImage from '../../assets/images/mobile-hero.svg'
import DesktopHeroEnglish from '../../assets/images/desktop-hero-english.svg'
import DesktopHeroPortuguese from '../../assets/images/desktop-hero-portugese.svg'
import DesktopHeroSwedish from '../../assets/images/desktop-hero-swedish.svg'
import DesktopHeroGerman from '../../assets/images/desktop-hero-german.svg'
import { useTranslation } from 'react-i18next'

const HeroContent = ({ onClick }) => {
  const { t } = useTranslation();

  // Map translation keys to imported images
  const desktopImages = {
    'desktop-hero-english.svg': DesktopHeroEnglish,
    'desktop-hero-portugese.svg': DesktopHeroPortuguese,
    'desktop-hero-swedish.svg': DesktopHeroSwedish,
    'desktop-hero-german.svg': DesktopHeroGerman,
  }

  const DesktopImage = desktopImages[t('content.heroImage')] || DesktopHeroEnglish
  return (
    <>
      <HeroContentWrapper>
        <div>
          <HeadingExtraLarge
            $customStyle={customHeadingExtraLarge}
            data-testid="landing-page-heading"
          >
            { t('content.title') }
          </HeadingExtraLarge>
          <HeadingExtraSmall
            as="h2"
            $customStyle={customHeadingExtraSmall}
            data-testid="landing-page-subheading"
          >
            { t('content.subtitle') }
          </HeadingExtraSmall>
          <ContentLarge
            $customStyle={customContentLarge}
            data-testid="landing-page-instructions"
          >
            { t('content.text')}
          </ContentLarge>
        </div>
      </HeroContentWrapper>
      <HeroArtwork>
        <img
          src={DesktopImage}
          className="desktop"
          alt="an example of a 'person' card and a 'trait' card"
          data-testid="example-person-trait-card"
        />
        <MobileHeroImage
          src={MobileImage}
          alt="an image of two cards"
          className="mobile"
        />
      </HeroArtwork>
      <DealButton
        text={ t('content.dealCards') }
        onClick={onClick}
        data-testid="deal-cards-button"
        dataTestId="deal-cards-button-text"
      />
    </>
  )
}

export { HeroContent }
